<template>
    <div class="progress"
         :title="data">
        <div :aria-valuenow="data"
             :class="this.barColor"
             :style="'width: '+(this.data * 20)+'%'"
             aria-valuemax="5"
             aria-valuemin="0"
             class="progress-bar"
             role="progressbar">
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                class: 'bg-danger'
            }
        },
        props: {
            data: null
        },
        computed: {
            barColor() {
                let data = this.data
                if (data <= 2) {
                    return 'bg-success'
                } else if (data > 2 && data <= 4) {
                    return 'bg-warning'
                } else {
                    return 'bg-danger'
                }
            }
        },
    }
</script>
